/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { difference } from "lodash";

import Modal from "../../Modal";
import { mode } from "../../../helpers/types";
import messages from "../../../helpers/messages";

function AdditionalModesWarningModal({
  open,
  modes,
  winningModes,
  handleClose,
  handleBackButton,
  handleContinueButton
}) {
  const losingModes = difference(modes, winningModes);
  const modesText = losingModes.map(x => {
    if (x.mode === mode.tl) {
      return messages.truckload.defaultMessage;
    } else if (x.mode === mode.ltl) {
      return messages.lessThanTruckload.defaultMessage;
    } else {
      return messages.intermodal.defaultMessage;
    }
  });

  return (
    <Modal
      title={messages.awardUpload.defaultMessage}
      open={open}
      large
      handleClose={handleClose}
      titleClass="modal__title_light uppercase"
      bodyClass="border-top-grey px-24 pt-24 award-upload"
      closeButtonClass="modal__close-button mr-16 mt-16"
    >
      <p className="font-size-16 text-dim-grey mb-20">
        {messages.thisBidIncludesTheFollowingAdditionalModes.defaultMessage}
      </p>
      <p className="font-size-16 text-dim-grey mb-20 font-bold">
        {modesText.map(text => (
          <li key={text} className="block">
            {text}
          </li>
        ))}
      </p>
      <p className="font-size-16 text-dim-grey">
        {messages.additionalModesWarningMessage.defaultMessage}
      </p>
      <div className="grid fr">
        <div className="grid__cell mb-24 mr-16">
          <button
            data-testid="back-button"
            className="secondary-button one-whole cursor-pointer univers-67-bold-cond"
            style={{ minWidth: "120px" }}
            onClick={handleBackButton}
          >
            {messages.back.defaultMessage}
          </button>
        </div>
        <div className="grid__cell mb-24">
          <button
            data-testid="continue-button"
            className="primary-button one-whole cursor-pointer univers-67-bold-cond"
            style={{ minWidth: "120px" }}
            onClick={handleContinueButton}
          >
            {messages.continue.defaultMessage}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default AdditionalModesWarningModal;
